// --- CLEAN + FIXED VERSION --- //

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, getDocs, orderBy, limit } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from "../../components_root/ToastContext.jsx";
import { Randomcode } from "../../components_root/rendom_code.js";
import {
    MdArrowBackIos,
    MdClose,
    MdAccountCircle,
    MdPrint,
    MdSaveAs
} from "react-icons/md";
import "./voucher_entry.css";
import AmountToWords from "../../components_root/AmountToWords.js";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
import { Randomnumber } from "../../components_root/rendom_number.js";
import { Save_voucher_ledger } from "./save_voucher_ledger.js";
import Print_vouchers from "../print_root/print_vouchers.js";
import Account_list_profile_popup from "../ledger_accounts_root/account_list_profile_popup.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools",
    description: "Discover free & premium online services on aooz.",
    keywords: "tools, seo, utilities",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};

// -----------------------
// FORMAT ACCOUNT NUMBER
// -----------------------
export function formatAccountNumber(num, length = 13) {
    if (!num) return "";
    return String(num).padStart(length, "0");
}

export default function Voucher_withdrawal() {
    const location = useLocation();
    const navigate = useNavigate();
    const { Toastshow } = Toast();
    const servicetablename = "accountingfinancedb";
    const [voucherid, setVoucherid] = useState();
    const [voucher, setVoucher] = useState("");
    const [voucher_type, setVoucher_type] = useState("");
    const [amount, setAmount] = useState("");
    const [totalamount, setTotalamount] = useState(0);
    const [voucherprintid, setVoucherprintid] = useState(Randomcode(22));
    const [vouchernumber, setvouchernumber] = useState(Randomnumber(13));

    const [description, setdescription] = useState("");
    const [voucherdate, setVoucherdate] = useState("");
    const [print, setPrint] = useState(false);

    const [fromsearchstatus, setFromsearchstatus] = useState(true);
    const [tosearchstatus, setTosearchstatus] = useState(false);
    const [from_accountdata, setFrom_accountdata] = useState([]);
    const [from_accountguid, setFrom_accountguid] = useState("");
    const [to_accountguid, setTo_accountguid] = useState("");

    const select_company_uid = Cookies.get("select_company_uid");

    const [to_balance, setTo_balance] = useState(0);
    const [balance, setBalance] = useState(0);
    const [printId, setPrintId] = useState();
    const [profileopen, setProfileopen] = useState(false);
    const toggleProfile = () => {
        setProfileopen(prev => !prev);
    };
    // -----------------------
    // READ PARAMS
    // -----------------------
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const uid = params.get("accountguid");
        const slug = params.get("page");

        if (uid) setFrom_accountguid(uid);

        if (slug) {
            get_voucher(slug);
        } else {
            navigate("/accounting?page=account_ledger");
        }
    }, [window.location.search]);
    // -----------------------
    // GET VOUCHER DATA
    // -----------------------
    const get_voucher = async (slug) => {
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "vouchers"
        );

        const QueryData = query(
            ledgerCollection,
            where("status", "==", true),
            where("slug", "==", slug)
        );
        const Snap = await getDocs(QueryData);
        if (Snap.empty) {
            //navigate("/accounting?page=vouchers_master");
            Toastshow("Voucher does not exist");
            return;
        }
        const Doc = Snap.docs[0].data();
        setVoucherid(Doc.voucherid);
        setVoucher(Doc.voucher);
        setVoucher_type(Doc.voucher_type);
        //  get_account_ledger_master(Doc.voucherid);
    };
    // -----------------------
    // GET MASTER ACCOUNT
    // -----------------------
    // const get_account_ledger_master = async (voucherid) => {
    //     const ledgerCollection = collection(
    //         db,
    //         servicetablename,
    //         select_company_uid,
    //         "ledger_accounts_manager");

    //     const QueryData = query(
    //         ledgerCollection,
    //         where("account_type", "==", "master"),
    //         where("status", "==", true),
    //         where("ledger_account", "==", true),
    //         where("voucherid", "==", voucherid)
    //     );
    //     const Snap = await getDocs(QueryData);
    //     if (Snap.empty) {
    //         Toastshow("Voucher master does not exist");
    //         return;
    //     }
    //     const docData = Snap.docs[0].data();
    //     setTosearchstatus(true);
    //     setTo_accountguid(docData.accountguid);
    // };
    useEffect(() => {
        setVoucherdate(new Date().toLocaleString());
    }, [from_accountguid]);
    // -----------------------
    // GET FROM ACCOUNT DATA
    // -----------------------
    useEffect(() => {
        const handle_from_accountgnumber = async (guid) => {
            if (!guid) return;
            try {
                const snap = await getDocs(
                    query(
                        collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                        where("accountguid", "==", guid)
                    )
                );
                if (!snap.empty) {
                    const list = snap.docs.map((docSnap) => ({
                        id: docSnap.id,
                        ...docSnap.data(),
                    }));
                    setFrom_accountdata(list);
                } else {
                    setFrom_accountdata([]);
                }
            } catch (e) {
                console.error(e);
            }
        };
        handle_from_accountgnumber(from_accountguid);
    }, [from_accountguid]);

    // -----------------------
    // SAVE FUNCTION
    // -----------------------
    const handle_save_voucher = async () => {
        if (!voucherid) {
            Toastshow("Voucher ID missing");
            return;
        }
        if (!voucherprintid) {
            Toastshow("Print ID missing");
            return;
        }
            if (from_accountguid === to_accountguid) {
            Toastshow("Select Account missing");
            return;
        }
           if (!from_accountguid && fromsearchstatus === false) {
            Toastshow("From account missing");
            return;
        }
             if (!to_accountguid && tosearchstatus === false) {
            Toastshow("To account missing");
            return;
        }
        if (!amount || Number(amount) === 0) {
            Toastshow("Please enter amount");
            return;
        }
        const payload = {
            voucher,
            description,
            voucherid,
            voucherprintid,
            vouchernumber,
            voucher_type,
            from_accountguid,
            to_accountguid,
            status: true,
            namepaying: from_accountdata?.name || "",
            mobile: from_accountdata?.mobile || "",
            accountnumber: from_accountdata?.accountnumber || "",
            payment_method_online: false,
            amount: Number(amount) || 0,
            totalamount: Number(totalamount) || 0
        };
        const result = await Save_voucher_ledger(payload);
        if (result.success) {
            if (print === true) setPrintId(voucherprintid);
            setvouchernumber(Randomnumber(13));
            setVoucherprintid(Randomcode(22));
            setAmount("");
            setTotalamount("");
            setVoucherdate(new Date().toLocaleString());
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    // -----------------------
    // ESCAPE KEY → BACK
    // -----------------------
    useEffect(() => {
        const handle = (e) => e.key === "Escape" && navigate(-1);
        window.addEventListener("keydown", handle);
        return () => window.removeEventListener("keydown", handle);
    }, []);
    // -----------------------
    // TO ACCOUNT BALANCE LISTENER
    // -----------------------
    useEffect(() => {
        if (!select_company_uid || !to_accountguid) return;
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );
        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", to_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );
        const unsubscribe = onSnapshot(lastQuery, (snapshot) => {
            if (!snapshot.empty) {
                setTo_balance(snapshot.docs[0].data().balance || 0);
            } else {
                setTo_balance(0);
            }
        });
        return () => unsubscribe();
    }, [to_accountguid]);
    // -----------------------
    // FROM ACCOUNT BALANCE (BUG FIXED: correct dependency)
    // -----------------------
    useEffect(() => {
        if (!select_company_uid || !from_accountguid) return;
        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );
        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", from_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );
        const unsubscribe = onSnapshot(lastQuery, (snapshot) => {
            if (!snapshot.empty) {
                setBalance(snapshot.docs[0].data().balance || 0);
            } else {
                setBalance(0);
            }
        });
        return () => unsubscribe();
    }, [from_accountguid]);

    const handle_to_search_accountgnumber = async (accountnumber) => {
        if (!accountnumber) return setTosearchstatus(false);

        try {

            const snap = await getDocs(
                query(
                    collection(db, servicetablename, select_company_uid, "ledger_accounts"),
                    where("accountnumber", "==", accountnumber)
                )
            );

            if (!snap.empty) {
                setTosearchstatus(true);
                setTo_accountguid(snap.docs[0].data().accountguid);
            } else {
                setTosearchstatus(false);
            }
        } catch (e) {
            console.error(e);
            setTosearchstatus(false);
        }
    };
    useEffect(() => {
        const sessiontoken = Cookies.get("sessiontoken");
        const guid = Cookies.get("guid");

        if (!sessiontoken || !guid || !select_company_uid) return;

        const ledgerCollection = collection(
            db,
            servicetablename,
            select_company_uid,
            "ledger_books"
        );

        const lastQuery = query(
            ledgerCollection,
            where("accountguid", "==", to_accountguid),
            orderBy("date_time", "desc"),
            limit(1)
        );

        // real-time listener
        const unsubscribe = onSnapshot(
            lastQuery,
            (snapshot) => {
                if (!snapshot.empty) {
                    const balance = snapshot.docs[0].data().balance || 0;
                    setTo_balance(balance);
                } else {
                    setTo_balance(0);
                }
            },
            (error) => {
                setTo_balance(0);
            }
        );

        return () => unsubscribe();

    }, [to_accountguid]);
    const PrintReceiptVoucher = (id) => setPrintId(id);


    return (
        <div>

            {/* HEADER */}
            <div className="b-bottom">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div
                                    onClick={() => navigate("/accounting?page=account_ledger")}
                                    className="button-ui0 text-h2 bold p-2 cursor fcap"
                                >
                                    <MdArrowBackIos className="icon" /> {voucher || "Not installed"}
                                </div>
                            </td>

                            <td width={30}>
                                <div
                                    onClick={() => navigate("/accounting")}
                                    className="button-ui0 p-2 cursor"
                                >
                                    <MdClose className="icon" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* DATE + RECEIPT */}
            <div className="b-bottom items-back-fill p-11">
                <table>
                    <tbody>
                        <tr>
                            <td className="text-h3"># {vouchernumber}</td>
                            <td width={160} className="text-h3 text-r">
                                Date: {voucherdate}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* BODY */}
            <div className="voucher-entry-body">

                {/* GRID */}
                <div className="ui-grid-4-equal m-top">

                    {/* FROM ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon red" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold red">
                                                            From account
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="button-ui2 p-2 fill text-h2">
                                            Balance: ₹<div className="bold">{balance}</div> /-
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">
                                            {fromsearchstatus && (
                                                <Ledger_accounts_profile accountguid={from_accountguid} />
                                            )}
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    {/* TO ACCOUNT */}
                    <div className="items-ui">
                        <table>
                            <tbody>
                                <tr>
                                    <td>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td width={25}>
                                                        <MdAccountCircle className="icon green" />
                                                    </td>
                                                    <td>
                                                        <div className="text-h2 bold green">
                                                            To Account number (Enter last digit)
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input className="p-11"
                                            onFocus={() => toggleProfile()}
                                            onChange={(e) => { handle_to_search_accountgnumber(e.target.value); }}
                                            placeholder="Enter to pay account number" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="button-ui2 p-2 fill text-h2">
                                            Balance: ₹<div className="bold">{to_balance}</div> /-
                                        </div>
                                    </td>
                                </tr>

                                <tr>
                                    <td>
                                        <div className="items-back-fill rounded">
                                            {tosearchstatus && (
                                                <Ledger_accounts_profile accountguid={to_accountguid} />
                                            )}
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <div className="items-ui"></div>

                    {/* AMOUNT */}
                    <div className="items-ui text-r">
                        <table>
                            <tbody>
                                <tr>
                                    <td><div className="text-h2 cap">Amount</div></td>
                                    <td width={20}><span className="text-h1">₹</span></td>

                                    <td width={150}>
                                        <input
                                            maxLength={20}
                                            className="p-1 bold text-h1"
                                            placeholder="Enter amount"
                                            value={amount}
                                            onChange={(e) => {
                                                let v = e.target.value.replace(/[^0-9.]/g, "");
                                                const p = v.split(".");
                                                if (p.length > 2) v = p[0] + "." + p.slice(1).join("");
                                                setAmount(v);
                                                setTotalamount(v);
                                            }}
                                        />
                                    </td>

                                    <td width={20}>
                                        <div
                                            onClick={() => {
                                                setAmount(balance);
                                                setTotalamount(balance);
                                            }}
                                            className="text-h2 cursor text-off"
                                        >
                                            Max
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                {/* TOTAL */}
                <div className="ui-grid-4-equal m-top b-bottom">
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>
                    <div className="items-ui"></div>

                    <div className="items-ui text-r">
                        <div className="items-back p-11">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <div className="text-h2 bold">Total amount</div>
                                        </td>
                                        <td className="text-r">
                                            <span className="text-h1 bold">₹{totalamount}/-</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <AmountToWords amount={amount} />
                        </div>
                    </div>
                </div>

                {/* REMARKS & SAVE/PRINT */}
                <div className="ui-grid-4-equal m-top">

                    <div className="items-ui m-1">
                        <input className="bold text-h2" placeholder="Ref Number option" maxLength={200} />
                        <textarea
                            className="text-h3"
                            maxLength={300}
                            placeholder="Remark"
                            value={description}
                            onChange={(e) => setdescription(e.target.value)}
                        />
                    </div>

                    <div className="items-ui"></div>
                    <div className="items-ui"></div>

                    <div className="items-ui m-1">

                        <label>
                            <input
                                type="checkbox"
                                checked={print}
                                onChange={(e) => setPrint(e.target.checked)}
                            />
                            <span className="text-h2">I want to save and print.</span>
                        </label>

                        <table>
                            <tbody>
                                <tr>
                                    {print ? (
                                        <td>
                                            <div
                                                className="button-ui fill text-h1 p-2 cursor green-back"
                                                onClick={handle_save_voucher}
                                            >
                                                <MdPrint className="icon" /> Print
                                            </div>
                                        </td>
                                    ) : (
                                        <td>
                                            <div
                                                className="button-ui fill text-h1 p-2 cursor"
                                                onClick={handle_save_voucher}
                                            >
                                                <MdSaveAs className="icon" /> Save
                                            </div>
                                        </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>

                    </div>

                </div>
            </div>

            {printId && (
                <Print_vouchers voucherprintid={printId} />
            )}
            <Account_list_profile_popup
                data={"accountguid"}
                isOpen={profileopen}
                onClose={() => setProfileopen(false)}
            />
        </div>
    );
}
